<div *ngIf="selectedMail" class="bg-white">
  <p-overlayPanel
              [styleClass]="'conv-overlay-options show-more-overlay'"
              #showMoreOptions
              [appendTo]="body"
              [target]="showMoreIcon1"
              [autoZIndex]="true">
              
              <div class="pt-2 participants-container">
              <span class="all-participants">All Participants</span>
              <img src="assets/qwyn/icons/red-cross.svg"
                    style="height: 13px; width: 13px;margin-left: 15px;"
                    alt="Close Icon"
                    class="close-icon"
                    (click)="showMoreRecipients($event, showMoreOptions, conversation)"  />
              </div>
              <span class="participants-list">To:</span>
              <!-- TO Recipients List -->
              <div class="recipients-list-container">
              <p-listbox [styleClass]="'listWrap'" [options]="conversation.toRecipients">
                <ng-template let-toRecipients pTemplate="item">
                  <div class="all-participants-list">{{toRecipients.displayName}}</div>
                </ng-template>
              </p-listbox>
              </div>

              <!-- CC Recipients Section -->
              <div *ngIf="conversation.ccRecipients?.length > 0" class="cc-section">
              <span class="participants-list" >CC:</span>
              <p-listbox [styleClass]="'listWrap'" [options]="conversation.ccRecipients">
                <ng-template let-ccRecipients pTemplate="item">
                  <div class="all-participants-list">{{ccRecipients.displayName}}</div>
                </ng-template>
              </p-listbox>
              </div>

              <!-- BCC Recipients Section -->
              <div *ngIf="conversation.bccRecipients?.length > 0" class="bcc-section">
              <span class="participants-list">BCC:</span>
              <p-listbox [styleClass]="'listWrap'" [options]="conversation.bccRecipients">
                <ng-template let-bccRecipients pTemplate="item">
                  <div class="all-participants-list">{{bccRecipients.displayName}}</div>
                </ng-template>
              </p-listbox>
              </div>
              </p-overlayPanel>
  <div class="d-flex flex-row justify-content-between align-items-center conv-header flex-unwrap ">
    <!-- <div (click)="onBackClick($event)" class="mob-img">
        <img class="backward-icon" src="assets/Inbox/right_chevron_icon.svg" alt="">
    </div> -->
    <div class="conv-subject">
      <div>{{draft.subject}}</div>
      <div class="countStyle">{{totalConversations}}</div>
    </div>
    <div class="d-flex align-content-end conv-info">
      <div class="d-flex justify-content-end ms-auto">       
        <div class="me-2 ellipsis-icon" (mouseenter)="onEditIconHover(true)" (mouseleave)="onEditIconHover(false)" (click)="onEditIconClick()" pTooltip="Edit Draft" tooltipPosition="top" tooltipStyleClass="leftTooltip ui-tooltip-text">
          <img [src]="editIconSrc" alt="" height="20" width="20">
        </div>
        <div class="me-2  ellipsis-icon" (click)="showOptions($event,conversationOptions)" pTooltip="See more actions" tooltipPosition="top" tooltipStyleClass="leftTooltip ui-tooltip-text">
          <img  [src]="'assets/Inbox/ellipsis.svg'" alt="">
        </div>
        <div
              class="closeIcon"
              pTooltip="Close"
              tooltipPosition="top"
              tooltipStyleClass="leftTooltip ui-tooltip-text"
              (click)="closeMailDetailView()"
            >
              <img src="assets/newMessage/messageCloseIcon.svg" />
            </div>
      </div>
    </div>
  </div>

  <div class="d-flex flex-column conversation-container" [ngClass]="{'':inboxViewMode === 'vertical', 'horizontal-bar-height':inboxViewMode === 'horizontal'}">
    <!-- Expanded view of message -->
    <div class="detail-view-body-container">
        <div class=" conv-schedule " *ngIf='scheduleForLater'>
          <div class="gap-2 conv-date">
            <img class="clock" [src]="'assets/qwyn/icons/clock.svg'" alt="">
            <div>
              <!-- {{scheduleForLater | date:'dd MMM h:mm a'}} -->
              SCHEDULED: {{scheduleForLater}}
            </div>
          </div>
          
          
            <button  
              (click)="cancelSchedule()" 
              class=" gap-2 conv-button " 
              pTooltip="Cancel" 
              tooltipPosition="top"
              tooltipStyleClass="leftTooltip ui-tooltip-text">
                <img src="assets/newMessage/messageCloseIcon.svg" alt="Cancel">
                <div>Cancel</div>
            </button>
        </div>
        <div class="imp-indicator" *ngIf="conversation.urgentFlag ==='Y'">
          <img class='' src='assets/Inbox/annexImp.svg' alt='Important'>
          <div class="imp-text">Message sent with High Importance</div>
        </div>
        <div class="d-flex pb-3 pt-2 border-tb">           
          <div class="profile-icon">
              <app-image-placeholder [recipient]="conversation.fromRecipient"></app-image-placeholder>                            
          </div>
          <div class="me-auto pt-2 d-flex flex-column min-wi1 justify-content-between">
            <div class="fs-12" [ngClass]="{'external': conversation.fromRecipient.isExternal}">
              {{conversation.fromRecipient.displayName}}                
            </div>
            <div #replyOverlay class="toText"
                  [ngClass]="{'external': isExternal(conversation.toRecipients)}"
                  title="{{getTruncatedEmail(conversation.toRecipients)}}"
                  (click)="displayContactInfo($event, opContactInfo, conversation.toRecipients)"
                  style="width: 100%;">
                  <span style="color: black;font-size: 12px;">To:&nbsp;</span>
                  <div class="overflow-hdn">
                    {{getTruncatedEmail(conversation.toRecipients)}}
                  </div>
                <span class="ms-1"> </span>

                  <!-- Show More - when CC or BCC exists -->
                <div *ngIf="(conversation.toRecipients.length > 2 || conversation.ccRecipients?.length >= 1 || conversation.bccRecipients?.length >= 1) && !isShowMorePanelVisible"
                  class="d-flex flex-column"
                  (click)="showMoreRecipients($event, showMoreOptions, conversation)"
                  #showMoreIcon1>
                <img src="assets/qwyn/icons/to-more-down-arrow.svg" alt="to" style="height: 12px;width: 12px; margin-bottom: -7px;" />
                <img src="assets/qwyn/icons/to-more-down-arrow.svg" alt="to" style="height: 12px;width: 12px;" />
                </div>

                <!-- Show More - when CC or BCC exists and panel is visible -->
                <div *ngIf="(conversation.toRecipients.length > 2 || conversation.ccRecipients?.length >= 1 || conversation.bccRecipients?.length >= 1) && isShowMorePanelVisible"
                  class="d-flex flex-column"
                  (click)="showMoreRecipients($event, showMoreOptions, conversation)"
                  #showMoreIcon1>
                <img src="assets/qwyn/icons/show-more-selected-up.svg" alt="to" style="height: 12px;width: 12px; margin-bottom: -7px;" />
                <img src="assets/qwyn/icons/show-more-selected-up.svg" alt="to" style="height: 12px;width: 12px;" />
                </div>

                <p-overlayPanel
                  #opContactInfo
                  [appendTo]="'body'"
                  [dismissable]="true"
                >
                  <gdir-contact-details
                    *ngIf="selectedContactId?.length>0"
                    [soeId]="selectedContactId"
                  ></gdir-contact-details>
                </p-overlayPanel>

                       <!-- Overlay Panel -->
              

              </div>
            <div class="fs-10-tocc" *ngIf='conversation.cc !== "" && recipientShow'>CC:
                <ng-template ngFor let-ccRecipients [ngForOf]="conversation.ccRecipients" let-idx="index">
                    <span [ngClass]="{'external': ccRecipients.isExternal}">{{ccRecipients.displayName}}</span>
                    <span *ngIf="idx != conversation.ccRecipients.length-1">; </span>
                </ng-template>
            </div>
            <div class="fs-10-tocc" *ngIf='conversation.bcc !== "" && recipientShow'>BCC:
                <ng-template ngFor let-bccRecipients [ngForOf]="conversation.bccRecipients" let-idx="index">
                    <span [ngClass]="{'external': bccRecipients.isExternal}">{{bccRecipients.displayName}}</span>
                    <span *ngIf="idx != conversation.bccRecipients.length-1">; </span>
                </ng-template>
            </div>
          </div>
          <div class="d-flex flex-column min-wi2">          
            <!--Attachment -->
            <div #attachOverlay class="d-flex justify-content-end align-items-center mt-2 mb-2 attach-position"
            *ngIf="conversation.attachmentCount>0" style="display: none!important">
              <div class="pe-1 align-self-end fs-11">
                <span *ngIf="conversation.attachmentCount == 1" title="{{conversation.attachments[0].name}}">
                              {{ (conversation.attachments[0].name.length>14) ? (conversation.attachments[0].name | slice:0:14)+'...':(conversation.attachments[0].name) }}
                          </span>
                <span *ngIf="conversation.attachmentCount > 1" class="download-text" (click)="onDownloadAttachment(conversation.attachments)"> Download All </span>
              </div>
              <div class="pe-2 attach-icon">
                <img [src]="'assets/Inbox/download_icon_u70.svg'" alt="" (click)="onDownloadAttachment(conversation.attachments)">
              </div>
              <div class="pe-2 attach-icon" *ngIf="conversation.attachmentCount > 1">
                <img [src]="'assets/Inbox/attachments_icon_selected_u107.svg'" alt="">
                <span class="fs-11">{{conversation.attachmentCount}}</span>
              </div>
              <div>
                <img class="opt-mr" [src]="'assets/Inbox/ellipsis_icon_selected_u101.svg'" alt="" (click)="showAttachments($event, attachmentOptions, conversation.attachments)">
                <!-- To show the list og attachments for the conversation -->
                <p-overlayPanel [styleClass]="'conv-overlay-options attach-overlay'" #attachmentOptions [appendTo]="attachOverlay">
                    <p-listbox [listStyle]="{'max-height':'120px'}" [options]="attachmentsOptions" (click)="onDownloadAction($event, attachmentOptions)">
                        <ng-template let-attachOpt pTemplate="item">
                            <div class="d-flex flex-row justify-content-between">
                                <div class="d-flex flex-row align-items-end">
                                    <div><img class="notes-icon" [src]="'assets/Inbox/notes_blue.svg'" alt="Notes"></div>
                                    <div class="ms-1 attach-name-opt" title="{{attachOpt.name}}">{{attachOpt.name}}</div>
                                </div>
                                <div class="ms-1"><img class="download-icon" [src]="'assets/Inbox/download_icon_u70.svg'" title="{{attachOpt.name}}" alt="Download"></div>
                            </div>
                        </ng-template>
                    </p-listbox>
                </p-overlayPanel>
              </div>
            </div>
            <!--Date Time -->
            <div class="ms-auto me-2 mt-auto fs-10">{{conversation.modDate | date:'dd MMM hh:mm a'}}</div>
          </div>
    
        </div>
   <!--  attachement redesign -->
            <!-- attachement panel less or upto 2 -->
            <div [ngClass]="isAttachemntPanelCollapsed ? 'attachement-grid-container-collapsed-view' : 'attachement-grid-container-expanded-view'"
            *ngIf="!isMobile && conversation?.attachments && conversation?.attachments.length>0 && conversation?.attachments.length<=2">
           <div class="container collapsed-view-more-than-two" 
           [ngClass]="{'attchement-grid-select-all-view': isSelectAllAttchClicked,
           'attchement-grid-one-attachement':conversation?.attachments.length === 1,
           'attchement-grid-one-attachement-with-select-all':conversation?.attachments.length === 1 
           && isSelectAllAttchClicked,
           'attchement-grid-two-attachement':conversation?.attachments.length === 2,
           'attchement-grid-two-attachement-with-select-all':conversation?.attachments.length === 2 
           && isSelectAllAttchClicked,
           'collapsed-view-more-than-two':conversation?.attachments.length > 2
          }">
               
               <ng-container *ngFor="let attachment of conversation.attachments;let i = index">
               
                   <div class="attachement-checkbox" *ngIf="i === 0">
                       <input type="checkbox" value="" [checked]="isSelectAllAttchClicked" (change)="isSelectAllAttchClicked = !isSelectAllAttchClicked">
                   </div>
                   <div class="attachement-checkbox" *ngIf="i !== 0 && i%3 === 0">
                           <!-- to create empty area below checkbox from second row onwards-->
                         
                    </div>
                   <div class="attachement-item" (mouseenter)="showAttachments(null, null, conversation?.attachments)"
                   > <!-- *ngIf="i<3" -->
               
                       <div class="box" *ngIf="attachment.showTitle" (mouseenter)="onMouseEnterAttTitle(attachment)" (mouseleave)="onMouseLeaveAttTitle(attachment)">
                           <!-- (mouseenter)="onMouseEnterAttTitle(attachment)" (mouseleave)="onMouseLeaveAttTitle(attachment)" -->
                           <!-- {{i}}  -->
                           <img class="download-icon" [src]="getAttachementImageByExtension(attachment)" alt="Download"/>
                           <div class="attachement-title">
                               {{attachment?.name}}
                           </div>
               
                       </div>
                       <!-- *ngIf="attachment.showMenu" -->
                       <div class="menu" *ngIf="attachment.showMenu" (mouseenter)="onMouseEnterAttMenu(attachment)" (mouseleave)="onMouseLeaveAttMenu(attachment)" ><!-- (mouseleave)="onMouseLeaveAttMenu(attachment)" -->
                           <div class="eye-icon">
                                      <!--  <img class="eye-img" src="assets/Inbox/eye.svg" 
                                       (click)="onViewctionRedesigned(attachment)" title="View"> -->
                            </div>
                            <div class="menu-icons-border"></div>   
                           <div > <!-- [src]="'assets/Inbox/download_icon_u70.svg'" -->
                               <img class="download-icon" [src]="'assets/Inbox/download_icon_u70.svg'" (click)="onDownloadAttachment(attachment)"  title="Download" alt="Download">
                           </div>
                           <div class="menu-icons-border">

                           </div>
                           <div>
                            <!--  <img class="copy-icon" [src]="getAttachementCopyIconRedesigned(attachment)" name="copy"
                                (click)="onCopyActionRedesigned(attachment,conversation.attachments)" title="Copy"> -->
                              </div>
                       </div>
                   </div>
                   <!-- show menu options when select all checkbox is checked -->

                   <div class="attachement-more" *ngIf="conversation?.attachments.length>3 && i === 2 && isAttachemntPanelCollapsed && !isSelectAllAttchClicked" (click)="onAttachementMoreClick()">
                       +({{conversation?.attachments.length-3}}) More 
                   </div>
                   <div class="attachement-more" *ngIf="conversation?.attachments.length>3 && i === 2 && !isAttachemntPanelCollapsed && !isSelectAllAttchClicked" (click)="onAttachementMoreClick()">
                           - Less
                   </div>
                  
                   <div class="attachement-more" *ngIf="(i+1) >3  && (i+1)%3===0">
                           <!-- to create empty area below checkbox from second row onwards-->
                          
                    </div>
                
               </ng-container>
               <div class="attachement-select-all-Menu" 
               *ngIf="(conversation?.attachments.length>3 && isSelectAllAttchClicked) 
                   || (conversation?.attachments.length === 2  && isSelectAllAttchClicked) 
                   || (conversation?.attachments.length === 3  && isSelectAllAttchClicked)
                   || (conversation?.attachments.length === 1  && isSelectAllAttchClicked)">
                   <div *ngIf="conversation?.attachments.length>3 && isAttachemntPanelCollapsed">
                        + ({{conversation?.attachments.length-3}})
                   </div>
                   
             `              <div class="attachement-menu-item">
                                  <!--  <img class="copy-icon" src='assets/Inbox/copy_icon.svg' name="copy"
                                    (click)="onCopyAllAttachment(conversation?.attachments)"> -->  <!-- (click)="onCopyAllAttachment(conversation.attachments)" -->
                           </div>
                           <div class="attachement-menu-item">
                               <img class="download-icon" [src]="'assets/Inbox/download_icon_u70.svg'" 
                               (click)="onDownloadAttachment(conversation?.attachments)" (mouseover)="imgSrc='assets/Inbox/download_icon_light_blue.svg'"
                               (mouseout)="imgSrc='assets/Inbox/download_icon_u70.svg'" alt="Download">
                           </div>
                  
                   
               </div>    
       </div>
       </div>
       <!-- Attachement Panel More than 2 Attachement collapsed View-->
       <div [ngClass]="isAttachemntPanelCollapsed ? 'attachement-grid-container-collapsed-view' : 'attachement-grid-container-expanded-view'"
            *ngIf="!isMobile && conversation?.attachments && conversation?.attachments.length>0 && conversation?.attachments.length>2 && !isSelectAllAttchClicked">
           <div class="container collapsed-view-more-than-two" 
           [ngClass]="{'attchement-grid-select-all-view': isSelectAllAttchClicked,
           'attchement-grid-one-attachement':conversation?.attachments.length === 1,
           'attchement-grid-one-attachement-with-select-all':conversation?.attachments.length === 1 
           && isSelectAllAttchClicked,
           'attchement-grid-two-attachement':conversation?.attachments.length === 2,
           'attchement-grid-two-attachement-with-select-all':conversation?.attachments.length === 2 
           && isSelectAllAttchClicked,
           'collapsed-view-more-than-two':conversation?.attachments.length > 2
          }">
               
               <ng-container *ngFor="let attachment of conversation?.attachments;let i = index">
               
                   <div class="attachement-checkbox" *ngIf="i === 0">
                       <input type="checkbox" value="" [checked]="isSelectAllAttchClicked" (change)="isSelectAllAttchClicked = !isSelectAllAttchClicked">
                   </div>
                   <div class="attachement-checkbox" *ngIf="i !== 0 && i%3 === 0">
                           <!-- to create empty area below checkbox from second row onwards-->
                         
                    </div>
                   <div class="attachement-item" (mouseenter)="showAttachments(null, null, conversation?.attachments)"
                   > <!-- *ngIf="i<3" -->
               
                       <div class="box" *ngIf="attachment.showTitle" (mouseenter)="onMouseEnterAttTitle(attachment)" (mouseleave)="onMouseLeaveAttTitle(attachment)">
                           <!-- (mouseenter)="onMouseEnterAttTitle(attachment)" (mouseleave)="onMouseLeaveAttTitle(attachment)" -->
                           <!-- {{i}}  -->
                           <img class="download-icon" [src]="getAttachementImageByExtension(attachment)" alt="Download" />
                           <div class="attachement-title">
                               {{attachment?.name}}
                           </div>
               
                       </div>
                       <!-- *ngIf="attachment.showMenu" -->
                       <div class="menu" *ngIf="attachment.showMenu" (mouseenter)="onMouseEnterAttMenu(attachment)" (mouseleave)="onMouseLeaveAttMenu(attachment)"><!-- (mouseleave)="onMouseLeaveAttMenu(attachment)" -->
                           <div class="eye-icon">
                                      <!--  <img class="eye-img" src="assets/Inbox/eye.svg" 
                                       (click)="onViewctionRedesigned(attachment)" title="View"> -->
                            </div>
                            <div class="menu-icons-border"></div>     
                           <div > <!-- [src]="'assets/Inbox/download_icon_u70.svg'" -->
                               <img class="download-icon" [src]="'assets/Inbox/download_icon_u70.svg'" (click)="onDownloadAttachment(attachment)" title="Download" alt="Download">
                           </div>
                           <div class="menu-icons-border">

                       </div>
                           <div>
                            <!--  <img class="copy-icon" [src]="getAttachementCopyIconRedesigned(attachment)" name="copy"
                                (click)="onCopyActionRedesigned(attachment,conversation.attachments)" title="Copy"> -->
                              </div>
                       </div>
                   </div>
                   <!-- show menu options when select all checkbox is checked -->

                   <div class="attachement-more" *ngIf="conversation?.attachments.length>3 && i === 2 && isAttachemntPanelCollapsed && !isSelectAllAttchClicked" (click)="onAttachementMoreClick()">
                       +({{conversation?.attachments.length-3}}) More
                   </div>
                   <div class="attachement-more" *ngIf="conversation?.attachments.length>3 && i === 2 && !isAttachemntPanelCollapsed && !isSelectAllAttchClicked" (click)="onAttachementMoreClick()">
                           - Less
                   </div>
                  
                   <div class="attachement-more" *ngIf="(i+1) >3  && (i+1)%3===0">
                           <!-- to create empty area below checkbox from second row onwards-->
                          
                    </div>
                
               </ng-container>
               <div class="attachement-select-all-Menu" 
               *ngIf="(conversation?.attachments.length>3 && isSelectAllAttchClicked) 
                   || (conversation?.attachments.length === 2  && isSelectAllAttchClicked) 
                   || (conversation?.attachments.length === 3  && isSelectAllAttchClicked)
                   || (conversation?.attachments.length === 1  && isSelectAllAttchClicked)">
                   <div *ngIf="conversation?.attachments.length>3 && isAttachemntPanelCollapsed">
                        + ({{conversation?.attachments.length-3}})
                   </div>
                   
                           <div class="attachement-menu-item">
                                   <!-- <img class="copy-icon" src='assets/Inbox/copy_icon.svg' name="copy" 
                                   (click)="onCopyAllAttachment(attachments)"> --> <!-- (click)="onCopyAllAttachment(conversation.attachments)" -->
                           </div>
                           <div class="attachement-menu-item">
                               <img class="download-icon" [src]="'assets/Inbox/download_icon_u70.svg'" 
                               (click)="onDownloadAttachment(attachments)" (mouseover)="imgSrc='assets/Inbox/download_icon_light_blue.svg'"
                               (mouseout)="imgSrc='assets/Inbox/download_icon_u70.svg'" alt="Download">
                           </div>
               </div>    
       </div>
       </div>

       <div [ngClass]="isSelectAllAttchClicked ? 'attachement-grid-container-collapsed-view' : 'attachement-grid-container-expanded-view'"
       *ngIf="!isMobile && conversation?.attachments && conversation?.attachments.length>0 && conversation?.attachments.length>2 && isSelectAllAttchClicked">
      <div class="container collapsed-view-more-than-two" 
      [ngClass]="isSelectAllAttchClicked? 'select-all-view-more-than-two': 'collapsed-view-more-than-two'">
          
          <ng-container *ngFor="let attachment of conversation?.attachments;let i = index">
          
              <div class="attachement-checkbox" *ngIf="i === 0">
                  <input type="checkbox" value="" [checked]="isSelectAllAttchClicked" (change)="isSelectAllAttchClicked = !isSelectAllAttchClicked; isAttachemntPanelCollapsed = true">
              </div>
              <div class="attachement-checkbox" *ngIf="i !== 0 && (i+1)%3 === 0">
                      <!-- to create empty area below checkbox from second row onwards-->
                    
               </div>
              <div class="attachement-item" (mouseenter)="showAttachments(null, null, conversation?.attachments)"
              > <!-- *ngIf="i<3" -->
          
                  <div class="box" *ngIf="attachment.showTitle" (mouseenter)="onMouseEnterAttTitle(attachment)" (mouseleave)="onMouseLeaveAttTitle(attachment)">
                      <!-- (mouseenter)="onMouseEnterAttTitle(attachment)" (mouseleave)="onMouseLeaveAttTitle(attachment)" -->
                      <!-- {{i}}  -->
                      <img class="download-icon" [src]="getAttachementImageByExtension(attachment)" alt="Download"/>
                      <div class="attachement-title">
                          {{attachment?.name}}
                      </div>
          
                  </div>
                  <!-- *ngIf="attachment.showMenu" -->
                  <div class="menu" *ngIf="attachment.showMenu" (mouseenter)="onMouseEnterAttMenu(attachment)" (mouseleave)="onMouseLeaveAttMenu(attachment)"><!-- (mouseleave)="onMouseLeaveAttMenu(attachment)" -->
                      <div class="eye-icon">
                                 <!--  <img class="eye-img" src="assets/Inbox/eye.svg" 
                                  (click)="onViewctionRedesigned(attachment)" title="View"> -->
                       </div> 
                       <div class="menu-icons-border">

                       </div>  
                      <div > <!-- [src]="'assets/Inbox/download_icon_u70.svg'" -->
                          <img class="download-icon" [src]="'assets/Inbox/download_icon_u70.svg'" (click)="onDownloadAttachment(attachment)" title="Download" alt="Download">
                      </div>
                      <div class="menu-icons-border">

                    </div>
                      <div>
                        <!-- <img class="copy-icon" [src]="getAttachementCopyIconRedesigned(attachment)" 
                       name="copy" (click)="onCopyActionRedesigned(attachment,conversation.attachments)" title="Copy"> -->
                      </div>
                  </div>
              </div>
              <!-- show menu options when select all checkbox is checked -->

              <div class="attachement-more" *ngIf="conversation?.attachments.length>3 && i === 2 && isAttachemntPanelCollapsed && !isSelectAllAttchClicked" (click)="onAttachementMoreClick()">
                  +({{conversation?.attachments.length-3}}) More
              </div>
              <div class="attachement-more" *ngIf="conversation?.attachments.length>3 && i === 2 && !isAttachemntPanelCollapsed && !isSelectAllAttchClicked" (click)="onAttachementMoreClick()">
                      - Less
              </div>
             
              <div class="attachement-more" *ngIf="(i+1) >3  && (i+1)%3===0 && !isAttachemntPanelCollapsed && !isSelectAllAttchClicked">
                      <!-- to create empty area below checkbox from second row onwards-->
                     
               </div>
               <div class="attachement-select-all-Menu" 
               *ngIf="i === 1">
                   <div *ngIf="conversation?.attachments.length>2 && isSelectAllAttchClicked" class="pe-3" style="display:flex;align-items: center; height:100%;background-color: white">
                        + ({{conversation?.attachments.length-2}})
                   </div>
                       <div class="d-flex" style="height:100%;">
                           <div class="attachement-menu-item">
                                   <!-- <img class="copy-icon" src='assets/Inbox/copy_icon.svg' name="copy"
                                    (click)="onCopyAllAttachment(conversation?.attachments)"> --> <!-- (click)="onCopyAllAttachment(conversation.attachments)" -->
                           </div>
                           <div class="attachement-menu-item">
                               <img class="download-icon" [src]="'assets/Inbox/download_icon_u70.svg'" 
                               (click)="onDownloadAttachment(conversation?.attachments)" (mouseover)="imgSrc='assets/Inbox/download_icon_light_blue.svg'"
                               (mouseout)="imgSrc='assets/Inbox/download_icon_u70.svg'" alt="Download">
                           </div>
                       </div>
                   
               </div> 
          </ng-container>
            
  </div>
  
  </div>
  <div class="bdr-btmss">

    </div>
      <div class="d-flex flex-column  msg-content">
        <div [innerHTML]="conversation.content | safeHtml"> </div>
      </div>
    </div>
  </div>

</div>

<div *ngIf="!selectedMail" class="detail-view-no-message">
  <div>
      Select an item to read
  </div>
</div>
<!-- To show options for the conversations -->
<p-overlayPanel [styleClass]="'conv-overlay-options'" #conversationOptions [appendTo]="'body'">
    <p-listbox [options]="options" (click)="onAction($event, conversationOptions)">
        <ng-template let-conOpt pTemplate="item">
            <div class="opt-items"> {{conOpt.name}}</div>
        </ng-template>
    </p-listbox>
</p-overlayPanel>